export default "__VITE_ASSET__CJkgAI$K__"